import { ReactComponent as Icon } from '../../assets/icons/support.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" />;
}
